import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ErrorMessageComponent } from '@utils/error-message.component';
import { RusPipe } from '@pipes';

import { EditorViewerComponent } from './viewer.component';
import { MenitonViewComponent } from './mentions/mention-view.component';

@NgModule({
    imports: [
        CommonModule,
        RusPipe, ErrorMessageComponent, MenitonViewComponent
    ],
    declarations: [
        EditorViewerComponent
    ],
    exports: [EditorViewerComponent],
})
export class TextViewerModule { }
